import { getWebCookie } from "@/libs/utils";
import { LinkedinUrl } from "@/config";
import { getCookie } from "@/libs/chrome";
// import { getGraphqlQueryParams } from "@/content-script/linkedin/dom";
import { getLinkedinStore } from "@/libs/ChromeStore";
// import { ChromeCache } from "@/libs/ChromeCache";
import {
  getLinkedinCompany,
  getLinkedinProfile as getLinkedinProfileApi,
} from "@i.un/libs";
import { ChromeCache } from "@/libs/ChromeCache";

const LinkedinApiUrl = LinkedinUrl + "/voyager/api";

const CacheTTL = 60 * 60 * 1000; // linkedin数据缓存有效时间 1 hour

async function getLinkedinCsrfToken() {
  return getWebCookie(LinkedinUrl, "JSESSIONID");
}

/**
 * 检查linkedin是否登录, 内容脚本不可直接用
 * 仅在插件环境使用
 * @returns Promise<boolean>
 */
export async function checkLinkedinLogin() {
  return !!(await getCookie(LinkedinUrl, "li_at"));
  // return chrome.cookies
  //   .getAll({ url: LinkedinUrl })
  //   .then((cookies) => {
  //     const hasLiAtCookie = cookies.some((cookie) => cookie.name === "li_at");
  //     return hasLiAtCookie;
  //   });

  // const csrfToken = await getLinkedinCsrfToken();
  // if (!csrfToken) {
  //   return false;
  // }

  // return fetch(LinkedinUrl + "/voyager/api/me", {
  //   headers: {
  //     "csrf-token": csrfToken,
  //   },
  // })
  //   .then((res) => {
  //     if (res.ok) {
  //       return true;
  //     }
  //     return false;
  //   })
  //   .catch((err) => {
  //     return false;
  //   });
}

/**
 * 获取linkedin用户邮箱
 * @param publicId 用户id
 * @returns Promise<string>
 */
// export async function getLinkedinProfileEmail(publicId: string) {
//   return getLinkedinProfileContactInfo(publicId).then(async (res) => res?.emailAddress || "");
// }

/**
 * 解析 LinkedIn 头像图片对象，返回图片的 url 和过期时间
 * @param pictureObj LinkedIn 头像图片对象
 * @returns { expiresAt: number | null, url: string }
 */
// function parseLinkedinProfileImage(pictureObj: any) {
//   const result: { expiresAt: number | null; url: string } = {
//     expiresAt: null,
//     url: "",
//   };

//   // 兼容不同格式的图片对象
//   const imageObj =
//     pictureObj?.["com.linkedin.common.VectorImage"] || pictureObj?.vectorImage;

//   if (!imageObj) {
//     return result;
//   }

//   // 获取过期时间
//   result.expiresAt = imageObj.artifacts?.[0]?.expiresAt ?? null;

//   // 获取图片根地址
//   result.url = imageObj.rootUrl || "";

//   // 拼接图片路径片段，优先取 artifacts[1] 的 fileIdentifyingUrlPathSegment
//   if (result.url && Array.isArray(imageObj.artifacts)) {
//     let segment = "";
//     if (imageObj.artifacts[1]?.fileIdentifyingUrlPathSegment) {
//       segment = imageObj.artifacts[1].fileIdentifyingUrlPathSegment;
//     } else if (imageObj.artifacts[2]?.fileIdentifyingUrlPathSegment) {
//       segment = imageObj.artifacts[2].fileIdentifyingUrlPathSegment;
//     } else if (imageObj.artifacts[0]?.fileIdentifyingUrlPathSegment) {
//       segment = imageObj.artifacts[0].fileIdentifyingUrlPathSegment;
//     }
//     result.url += segment;
//   }

//   return result;
// }

// export async function getLinkedinProfileByGraphql(publicId: string) {
//   let queryParams = getGraphqlQueryParams();
//   const LinkedinStore = getLinkedinStore();
//   if (queryParams) {
//     LinkedinStore.set("GraphqlQueryParams", queryParams);
//   } else {
//     const graphqlQueryParams = await LinkedinStore.get("GraphqlQueryParams");
//     if (graphqlQueryParams) {
//       queryParams = graphqlQueryParams;
//     }
//   }
//   if (!queryParams) {
//     return null;
//   }

//   return fetch(
//     LinkedinApiUrl +
//       "/graphql?includeWebMetadata=true&variables=(vanityName:" +
//       publicId +
//       ")&queryId=" +
//       queryParams.queryId,
//     {
//       headers: {
//         "csrf-token": await getLinkedinCsrfToken(),
//         ...queryParams?.headers,
//       },
//     },
//   ).then(async (res) => {
//     if (res.ok) {
//       const data = await res.json();
//       // console.log("res", data);
//       return (
//         data.data?.identityDashProfilesByMemberIdentity?.elements?.[0] || null
//       );
//     }
//     return null;
//   });
// }

// 已废弃
export async function getLinkedinProfileContactInfo(publicId: string) {
  return fetch(
    LinkedinApiUrl + "/identity/profiles/" + publicId + "/profileContactInfo",
    {
      headers: {
        "csrf-token": await getLinkedinCsrfToken(),
      },
    },
  ).then(async (res) => {
    if (res.ok) {
      return res.json();
    }
    return null;
  });
}

(globalThis as any).getLinkedin = async function ({
  url,
  path,
  method = "GET",
  body,
  headers,
}: {
  url?: string;
  path?: string;
  method?: string;
  body?: any;
  headers?: any;
}) {
  url = url || LinkedinApiUrl + path;
  if (method === "GET" && body) {
    url +=
      (url.includes("?") ? "&" : "?") + new URLSearchParams(body).toString();
  }
  const fetchHeaders = {
    ...headers,
    "csrf-token": await getLinkedinCsrfToken(),
  };
  if (method === "POST") {
    // fetchHeaders["Content-Type"] = "application/json";
  }
  console.log(url);
  return fetch(url, {
    method,
    body: body && method !== "GET" ? JSON.stringify(body) : undefined,
    headers: fetchHeaders,
  } as any)
    .then((res) => {
      if (res.ok) {
        return res.json().then((data) => {
          console.log("data", data);
          // ChromeCache.set(chromeCacheKey, data);
          return data;
        });
      } else {
        console.log("res", res);
      }
      return null;
    })
    .catch((err) => {
      console.log("err", err);
      return null;
    });
};

/**
 * 获取linkedin用户信息
 * @param publicId 用户id
 * @returns Promise<any>
 */
export async function getLinkedinProfile(publicId: string) {
  const chromeCacheKey = `lp_o_${publicId}` as const;
  const cachedData = await ChromeCache.get(chromeCacheKey);
  if (cachedData) {
    return cachedData;
  }

  return getLinkedinProfileApi(publicId, {
    csrfToken: await getLinkedinCsrfToken(),
    // cookies: await getWebCookie(LinkedinUrl, "JSESSIONID"),
  })
    .then((data) => {
      ChromeCache.set(chromeCacheKey, data, { ttl: CacheTTL });
      return data;
    })
    .catch((err) => {
      console.log("err", err);
      return null;
    });

  // 已废弃
  // return fetch(
  //   LinkedinApiUrl + "/identity/profiles/" + publicId + "/profileView",
  //   {
  //     headers: {
  //       "csrf-token": await getLinkedinCsrfToken(),
  //     },
  //   }
  // ).then((res) => {
  //   if (res.ok) {
  //     return res.json().then((data) => {
  //       // ChromeCache.set(chromeCacheKey, data);
  //       return data;
  //     });
  //   }
  //   return null;
  // });
}
// (window as any).getLinkedinProfile = getLinkedinProfile;

// export async function getLinkedinCompanyByUrn(urn: string) {
//   return fetch(LinkedinApiUrl + "/organization/companies/" + urn, {
//     headers: {
//       "csrf-token": await getLinkedinCsrfToken(),
//     },
//   }).then((res) => {
//     if (res.ok) {
//       return res.json();
//     }
//     return null;
//   });
// }

export async function getLinkedinCompanyByUniversalName(universalName: string) {
  const chromeCacheKey = `lc_o_${universalName}` as const;
  const cachedData = await ChromeCache.get(chromeCacheKey);
  if (cachedData) {
    return cachedData;
  }

  return getLinkedinCompany(universalName, {
    csrfToken: await getLinkedinCsrfToken(),
  }).then((res) => {
    if (res) {
      ChromeCache.set(chromeCacheKey, res, { ttl: CacheTTL });
      return res;
    }
    return null;
  });
}

/**
 * 获取linkedin用户头像
 * @param publicId 用户id
 * @returns Promise<string>
 */
// export async function getLinkedinProfilePhoto(publicId: string) {
//   const profile = await getLinkedinProfile(publicId);
//   const image = parseLinkedinProfileImage(
//     profile?.profile?.miniProfile?.picture
//   );
//   return image.url;
// }

// const profile = {
//   positionGroupView: {
//     paging: {
//       start: 0,
//       count: 5,
//       total: 6,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_positionGroupView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         timePeriod: {
//           startDate: {
//             month: 10,
//             year: 2017,
//           },
//         },
//         name: "LinkedIn",
//         positions: [
//           {
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,2391260019)",
//             companyName: "LinkedIn",
//             timePeriod: {
//               startDate: {
//                 month: 5,
//                 year: 2024,
//               },
//             },
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1337",
//                 entityUrn: "urn:li:fs_miniCompany:1337",
//                 name: "LinkedIn",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//                   },
//                 },
//                 universalName: "linkedin",
//                 dashCompanyUrn: "urn:li:fsd_company:1337",
//                 trackingId: "3xcM/JngQpy3H3yPCVRr0Q==",
//               },
//               employeeCountRange: {
//                 start: 10001,
//               },
//               industries: ["Computer Software"],
//             },
//             title: "VP Product, Chief of Staff to the Chief Product Officer",
//             companyUrn: "urn:li:fs_miniCompany:1337",
//           },
//           {
//             locationName: "San Francisco Bay Area",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,2067590443)",
//             geoLocationName: "San Francisco Bay Area",
//             geoUrn: "urn:li:fs_geo:90000084",
//             companyName: "LinkedIn",
//             timePeriod: {
//               endDate: {
//                 month: 5,
//                 year: 2024,
//               },
//               startDate: {
//                 month: 11,
//                 year: 2022,
//               },
//             },
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1337",
//                 entityUrn: "urn:li:fs_miniCompany:1337",
//                 name: "LinkedIn",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//                   },
//                 },
//                 universalName: "linkedin",
//                 dashCompanyUrn: "urn:li:fsd_company:1337",
//                 trackingId: "B7fQJt23TDyDEJ3VP8N6uw==",
//               },
//               employeeCountRange: {
//                 start: 10001,
//               },
//               industries: ["Computer Software"],
//             },
//             title:
//               "Senior Director of Product, Chief of Staff to the Chief Product Officer",
//             region: "urn:li:fs_region:(us,84)",
//             companyUrn: "urn:li:fs_miniCompany:1337",
//           },
//           {
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1717977049)",
//             companyName: "LinkedIn",
//             timePeriod: {
//               endDate: {
//                 month: 11,
//                 year: 2022,
//               },
//               startDate: {
//                 month: 12,
//                 year: 2020,
//               },
//             },
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1337",
//                 entityUrn: "urn:li:fs_miniCompany:1337",
//                 name: "LinkedIn",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//                   },
//                 },
//                 universalName: "linkedin",
//                 dashCompanyUrn: "urn:li:fsd_company:1337",
//                 trackingId: "YZpl+sBqSZyxy7W/MbbfIw==",
//               },
//               employeeCountRange: {
//                 start: 10001,
//               },
//               industries: ["Computer Software"],
//             },
//             title:
//               "Director of Product, Chief Of Staff to the Chief Product Officer",
//             companyUrn: "urn:li:fs_miniCompany:1337",
//           },
//           {
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1374234822)",
//             companyName: "LinkedIn",
//             timePeriod: {
//               endDate: {
//                 month: 12,
//                 year: 2020,
//               },
//               startDate: {
//                 month: 11,
//                 year: 2018,
//               },
//             },
//             description:
//               "Growth team - Led the product team responsible for acquisition (SEO, Logged out Experience, Mobile app downloads) & activation: helping members discover & learn how to use LinkedIn (new user onboarding experience & re-engagement of infrequent members)",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1337",
//                 entityUrn: "urn:li:fs_miniCompany:1337",
//                 name: "LinkedIn",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//                   },
//                 },
//                 universalName: "linkedin",
//                 dashCompanyUrn: "urn:li:fsd_company:1337",
//                 trackingId: "74afiSFkT2GZBtyNGz3DGQ==",
//               },
//               employeeCountRange: {
//                 start: 10001,
//               },
//               industries: ["Computer Software"],
//             },
//             title: "Group Product Manager",
//             companyUrn: "urn:li:fs_miniCompany:1337",
//           },
//           {
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1118557694)",
//             companyName: "LinkedIn",
//             timePeriod: {
//               endDate: {
//                 month: 10,
//                 year: 2018,
//               },
//               startDate: {
//                 month: 10,
//                 year: 2017,
//               },
//             },
//             description:
//               "Growth team - Responsible for growing LinkedIn's mobile app install base",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1337",
//                 entityUrn: "urn:li:fs_miniCompany:1337",
//                 name: "LinkedIn",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//                   },
//                 },
//                 universalName: "linkedin",
//                 dashCompanyUrn: "urn:li:fsd_company:1337",
//                 trackingId: "3tWZwnKWSL+ezNZhGbRzAw==",
//               },
//               employeeCountRange: {
//                 start: 10001,
//               },
//               industries: ["Computer Software"],
//             },
//             title: "Senior Product Manager",
//             companyUrn: "urn:li:fs_miniCompany:1337",
//           },
//         ],
//         paging: {
//           start: 0,
//           count: 5,
//           total: 5,
//           links: [],
//         },
//         miniCompany: {
//           objectUrn: "urn:li:company:1337",
//           entityUrn: "urn:li:fs_miniCompany:1337",
//           name: "LinkedIn",
//           showcase: false,
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//             },
//           },
//           universalName: "linkedin",
//           dashCompanyUrn: "urn:li:fsd_company:1337",
//           trackingId: "3xcM/JngQpy3H3yPCVRr0Q==",
//         },
//         entityUrn:
//           "urn:li:fs_positionGroup:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,0)",
//       },
//       {
//         timePeriod: {
//           endDate: {
//             month: 6,
//             year: 2020,
//           },
//           startDate: {
//             month: 5,
//             year: 2017,
//           },
//         },
//         name: "The Contemporary Jewish Museum",
//         positions: [
//           {
//             locationName: "San Francisco Bay Area",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1082127751)",
//             geoLocationName: "San Francisco Bay Area",
//             geoUrn: "urn:li:fs_geo:90000084",
//             companyName: "The Contemporary Jewish Museum",
//             timePeriod: {
//               endDate: {
//                 month: 6,
//                 year: 2020,
//               },
//               startDate: {
//                 month: 5,
//                 year: 2017,
//               },
//             },
//             description: "Board Of Trustees, Member-At-Large",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:85736",
//                 entityUrn: "urn:li:fs_miniCompany:85736",
//                 name: "The Contemporary Jewish Museum",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=Y9p7qcrzXDK1j3CbpNFvi6EuISwnax4jaYH6LOi1C4E",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=kBuvjEydS8fCWeGZZtep81ER_K2JhhQdC_USYRmF4Ho",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=3lD_mYl-Gj-Gq-UwMfLT_iGZoO2bagYY8ZH191PKZss",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQGrdQcL1Zq-tA/company-logo_",
//                   },
//                 },
//                 universalName: "the-contemporary-jewish-museum",
//                 dashCompanyUrn: "urn:li:fsd_company:85736",
//                 trackingId: "Kn3I/WLTQAK/bxVyyg3Wyg==",
//               },
//               employeeCountRange: {
//                 start: 51,
//                 end: 200,
//               },
//               industries: ["Museums and Institutions"],
//             },
//             title: "Board Of Trustees",
//             region: "urn:li:fs_region:(us,84)",
//             companyUrn: "urn:li:fs_miniCompany:85736",
//           },
//         ],
//         paging: {
//           start: 0,
//           count: 2,
//           total: 1,
//           links: [],
//         },
//         miniCompany: {
//           objectUrn: "urn:li:company:85736",
//           entityUrn: "urn:li:fs_miniCompany:85736",
//           name: "The Contemporary Jewish Museum",
//           showcase: false,
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=Y9p7qcrzXDK1j3CbpNFvi6EuISwnax4jaYH6LOi1C4E",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=kBuvjEydS8fCWeGZZtep81ER_K2JhhQdC_USYRmF4Ho",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=3lD_mYl-Gj-Gq-UwMfLT_iGZoO2bagYY8ZH191PKZss",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C560BAQGrdQcL1Zq-tA/company-logo_",
//             },
//           },
//           universalName: "the-contemporary-jewish-museum",
//           dashCompanyUrn: "urn:li:fsd_company:85736",
//           trackingId: "Kn3I/WLTQAK/bxVyyg3Wyg==",
//         },
//         entityUrn:
//           "urn:li:fs_positionGroup:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1)",
//       },
//       {
//         timePeriod: {
//           endDate: {
//             year: 2017,
//           },
//           startDate: {
//             year: 2012,
//           },
//         },
//         name: "Shopkick",
//         positions: [
//           {
//             locationName: "(Acquired by SK Planet, Oct 2014)",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,797851065)",
//             geoLocationName: "(Acquired by SK Planet, Oct 2014)",
//             companyName: "Shopkick",
//             timePeriod: {
//               endDate: {
//                 year: 2017,
//               },
//               startDate: {
//                 year: 2016,
//               },
//             },
//             description:
//               "Growth Team, Product Lead across\n-App Acquisition: Paid, Organic, Viral - Decreasing cost per user acquisition channels while maintaining high engagement rates \n-App Activation: On-boarding flows, in-app messaging, email & notification platform\nResults:  \n*Drove +40% YOY Activation rate \n-Led integration of new notification & email platform to scale comms efforts\n-Launched A/B testing framework for in-app messages, PNS, Emails\n-Developed new ROI methodology to measure impact of incentivized offers - resulting in significant cost savings",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:831240",
//                 entityUrn: "urn:li:fs_miniCompany:831240",
//                 name: "Shopkick by Trax",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/B4EZfFoz7pG4AM-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=yErUSSb1_W-XzDByQXM2KF2cQzIpVx8Kq3E6N4uxxXA",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/B4EZfFoz7pG4AU-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=TsjIDx3MYEsTsVeoygnqlqMMFAZH-tKAURkfJMAIAUo",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/B4EZfFoz7pG4Ac-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=voFAwD5UNjWdg08iPyWpmSLG6gFV45e1_W4_uzBmrlM",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/D4E0BAQEyeQtNrtlFVw/company-logo_",
//                   },
//                 },
//                 universalName: "shopkick",
//                 dashCompanyUrn: "urn:li:fsd_company:831240",
//                 trackingId: "UYpJp+PCTMOB48QJJ/R5hA==",
//               },
//               employeeCountRange: {
//                 start: 51,
//                 end: 200,
//               },
//               industries: ["Marketing and Advertising"],
//             },
//             title: "Principal Product Manager, Growth",
//             companyUrn: "urn:li:fs_miniCompany:831240",
//           },
//           {
//             courses: [
//               "urn:li:fs_course:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,205736794)",
//             ],
//             locationName: "(Acquired by SK Planet, Oct 2014)",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,829877197)",
//             geoLocationName: "(Acquired by SK Planet, Oct 2014)",
//             companyName: "Shopkick",
//             timePeriod: {
//               endDate: {
//                 year: 2016,
//               },
//               startDate: {
//                 year: 2012,
//               },
//             },
//             description:
//               "Product Manager, Core & Monetization features \n\nFounding member of the Brand Advertising Revenue Business group. \n*Our 3-person founding team included myself, Chief Revenue Officer (Alexis Rask) & Shopkick Co-Founder (Jeff Sellinger).\n*Defined and executed the go-to market strategy for our brand advertising business\n*Grew the business to first $10 Million annual revenue in 18 months\n\n\nHighlights include: \n*Drove 5x increase in-store credit card purchases & 200% increase in users linking cards \n*Introduced new ad formats - Branded Content Collections\n*VISA partnership - oversaw integration & acted as product stakeholder in contract negotiations \n*Build new \n*Shopkick Hackathon, Winning team - Birthday Feature\nAdditional Features Shipped: Shopkick deals tab, corporate website\n\nOwned product roadmaps across multiple features. Responsibilities included: strategy definition, prioritization, execution and post-launch analysis and optimization",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:831240",
//                 entityUrn: "urn:li:fs_miniCompany:831240",
//                 name: "Shopkick by Trax",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/B4EZfFoz7pG4AM-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=yErUSSb1_W-XzDByQXM2KF2cQzIpVx8Kq3E6N4uxxXA",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/B4EZfFoz7pG4AU-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=TsjIDx3MYEsTsVeoygnqlqMMFAZH-tKAURkfJMAIAUo",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/B4EZfFoz7pG4Ac-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=voFAwD5UNjWdg08iPyWpmSLG6gFV45e1_W4_uzBmrlM",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/D4E0BAQEyeQtNrtlFVw/company-logo_",
//                   },
//                 },
//                 universalName: "shopkick",
//                 dashCompanyUrn: "urn:li:fsd_company:831240",
//                 trackingId: "T9G/tSmgS2O8oD+I4DdtNQ==",
//               },
//               employeeCountRange: {
//                 start: 51,
//                 end: 200,
//               },
//               industries: ["Marketing and Advertising"],
//             },
//             title: "Product Manager, Brand advertising business founding team",
//             companyUrn: "urn:li:fs_miniCompany:831240",
//           },
//         ],
//         paging: {
//           start: 0,
//           count: 2,
//           total: 2,
//           links: [],
//         },
//         miniCompany: {
//           objectUrn: "urn:li:company:831240",
//           entityUrn: "urn:li:fs_miniCompany:831240",
//           name: "Shopkick by Trax",
//           showcase: false,
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/B4EZfFoz7pG4AM-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=yErUSSb1_W-XzDByQXM2KF2cQzIpVx8Kq3E6N4uxxXA",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/B4EZfFoz7pG4AU-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=TsjIDx3MYEsTsVeoygnqlqMMFAZH-tKAURkfJMAIAUo",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/B4EZfFoz7pG4Ac-/0/1751367499835/shopkick_logo?e=1757548800&v=beta&t=voFAwD5UNjWdg08iPyWpmSLG6gFV45e1_W4_uzBmrlM",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/D4E0BAQEyeQtNrtlFVw/company-logo_",
//             },
//           },
//           universalName: "shopkick",
//           dashCompanyUrn: "urn:li:fsd_company:831240",
//           trackingId: "UYpJp+PCTMOB48QJJ/R5hA==",
//         },
//         entityUrn:
//           "urn:li:fs_positionGroup:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,2)",
//       },
//       {
//         timePeriod: {
//           endDate: {
//             year: 2017,
//           },
//           startDate: {
//             year: 2016,
//           },
//         },
//         name: "Reforge",
//         positions: [
//           {
//             locationName: "San Francisco Bay Area",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1437062265)",
//             geoLocationName: "San Francisco Bay Area",
//             geoUrn: "urn:li:fs_geo:90000084",
//             companyName: "Reforge",
//             timePeriod: {
//               endDate: {
//                 year: 2017,
//               },
//               startDate: {
//                 year: 2016,
//               },
//             },
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:7970304",
//                 entityUrn: "urn:li:fs_miniCompany:7970304",
//                 name: "Reforge",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=0w27_ARDND9ppIGYHxgypE8dfSd7KRkqharOwuPpnlA",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=W9KBR_GqmgxEsepMJBhfdDgX8OY5ghGYZlCn7FSXCoU",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=8s_e-a0Tgs19XSmt7Z01nkY5QxLCnP62IdXiur1C5YM",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C560BAQFyuulckDgQ3w/company-logo_",
//                   },
//                 },
//                 universalName: "reforge",
//                 dashCompanyUrn: "urn:li:fsd_company:7970304",
//                 trackingId: "Agm3+fcFRpScuTszr+5D4w==",
//               },
//               employeeCountRange: {
//                 start: 51,
//                 end: 200,
//               },
//               industries: ["Computer Software"],
//             },
//             title: "Moderator",
//             region: "urn:li:fs_region:(us,84)",
//             companyUrn: "urn:li:fs_miniCompany:7970304",
//           },
//         ],
//         paging: {
//           start: 0,
//           count: 2,
//           total: 1,
//           links: [],
//         },
//         miniCompany: {
//           objectUrn: "urn:li:company:7970304",
//           entityUrn: "urn:li:fs_miniCompany:7970304",
//           name: "Reforge",
//           showcase: false,
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=0w27_ARDND9ppIGYHxgypE8dfSd7KRkqharOwuPpnlA",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=W9KBR_GqmgxEsepMJBhfdDgX8OY5ghGYZlCn7FSXCoU",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1672953318949/reforge_logo?e=1757548800&v=beta&t=8s_e-a0Tgs19XSmt7Z01nkY5QxLCnP62IdXiur1C5YM",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C560BAQFyuulckDgQ3w/company-logo_",
//             },
//           },
//           universalName: "reforge",
//           dashCompanyUrn: "urn:li:fsd_company:7970304",
//           trackingId: "Agm3+fcFRpScuTszr+5D4w==",
//         },
//         entityUrn:
//           "urn:li:fs_positionGroup:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,3)",
//       },
//       {
//         timePeriod: {
//           endDate: {
//             year: 2012,
//           },
//           startDate: {
//             year: 2010,
//           },
//         },
//         name: "Translation LLC",
//         positions: [
//           {
//             locationName: "New York, NY",
//             entityUrn:
//               "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,340352313)",
//             geoLocationName: "New York, NY",
//             companyName: "Translation LLC",
//             timePeriod: {
//               endDate: {
//                 year: 2012,
//               },
//               startDate: {
//                 year: 2010,
//               },
//             },
//             description:
//               "Translation marketing helps Fortune 500 brands connect authentically with the millennial audience via Entertainment, Music, Sports and Digital Integrations\n\n-Accounts: McDonald's, Target, Nokia, Wrigley's (Skittles, Orbit, brand/packaging innovation), Coca-Cola, Bud Light\n\n-Product innovation/New product launches\n-Influencer Strategy development\n-Social strategy and program execution\n-Managed biggest pitch and win in Agency history - Bud Light\n-Led inter‐agency teams to develop new strategic platforms and 360 creative campaigns\n\nCore Skills: Day to day lead client contact across multiple accounts, strategic development and execution of 360 campaigns, well versed in production (interactive, TV, print, radio, direct, in-store, DM), social engagement strategy, sponsorships, sports & entertainment alliances, new business pitches, young adult & multicultural marketing (research/insights)",
//             company: {
//               miniCompany: {
//                 objectUrn: "urn:li:company:1716475",
//                 entityUrn: "urn:li:fs_miniCompany:1716475",
//                 name: "Translation",
//                 showcase: false,
//                 active: true,
//                 logo: {
//                   "com.linkedin.common.VectorImage": {
//                     artifacts: [
//                       {
//                         width: 200,
//                         fileIdentifyingUrlPathSegment:
//                           "200_200/company-logo_200_200/0/1631341422849?e=1757548800&v=beta&t=nkSwF0hs9-A7BBW_7Sj-uv2TazQqLkXkf1kkdzwEfbA",
//                         expiresAt: 1757548800000,
//                         height: 200,
//                       },
//                       {
//                         width: 100,
//                         fileIdentifyingUrlPathSegment:
//                           "100_100/company-logo_100_100/0/1631341422849?e=1757548800&v=beta&t=EHmhJgGFhLVJcoJloZq2cKztbb_ymvEqnGM-Ocxb3NQ",
//                         expiresAt: 1757548800000,
//                         height: 100,
//                       },
//                       {
//                         width: 400,
//                         fileIdentifyingUrlPathSegment:
//                           "400_400/company-logo_400_400/0/1631341422849?e=1757548800&v=beta&t=iqE0iS72hhCzBSaX-2LHZcSdtSdfU9G7f5Rg4TjuK6M",
//                         expiresAt: 1757548800000,
//                         height: 400,
//                       },
//                     ],
//                     rootUrl:
//                       "https://media.licdn.com/dms/image/v2/C4D0BAQGTzGgidsTSvg/company-logo_",
//                   },
//                 },
//                 universalName: "translation-llc",
//                 dashCompanyUrn: "urn:li:fsd_company:1716475",
//                 trackingId: "r7IP6IxgTnC3+3dCoPqT/A==",
//               },
//               employeeCountRange: {
//                 start: 51,
//                 end: 200,
//               },
//               industries: ["Marketing and Advertising"],
//             },
//             title: "Manager, Digital & Influencer Marketing",
//             companyUrn: "urn:li:fs_miniCompany:1716475",
//           },
//         ],
//         paging: {
//           start: 0,
//           count: 2,
//           total: 1,
//           links: [],
//         },
//         miniCompany: {
//           objectUrn: "urn:li:company:1716475",
//           entityUrn: "urn:li:fs_miniCompany:1716475",
//           name: "Translation",
//           showcase: false,
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1631341422849?e=1757548800&v=beta&t=nkSwF0hs9-A7BBW_7Sj-uv2TazQqLkXkf1kkdzwEfbA",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1631341422849?e=1757548800&v=beta&t=EHmhJgGFhLVJcoJloZq2cKztbb_ymvEqnGM-Ocxb3NQ",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1631341422849?e=1757548800&v=beta&t=iqE0iS72hhCzBSaX-2LHZcSdtSdfU9G7f5Rg4TjuK6M",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C4D0BAQGTzGgidsTSvg/company-logo_",
//             },
//           },
//           universalName: "translation-llc",
//           dashCompanyUrn: "urn:li:fsd_company:1716475",
//           trackingId: "r7IP6IxgTnC3+3dCoPqT/A==",
//         },
//         entityUrn:
//           "urn:li:fs_positionGroup:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,4)",
//       },
//     ],
//   },
//   patentView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_patentView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   summaryTreasuryMediaCount: 0,
//   summaryTreasuryMedias: [],
//   educationView: {
//     paging: {
//       start: 0,
//       count: 3,
//       total: 2,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_educationView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         entityUrn:
//           "urn:li:fs_education:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,36770035)",
//         school: {
//           objectUrn: "urn:li:school:19225",
//           entityUrn: "urn:li:fs_miniSchool:19225",
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1631314412155?e=1757548800&v=beta&t=tlBQHgUhjECojfTi4XiknK33CjognMMQG_2bwNcxUjw",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1631314412155?e=1757548800&v=beta&t=ZXSVXgjBSoDIG3m29nXHGyjcX9j_3qZLb_x_grD8QI4",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1631314412155?e=1757548800&v=beta&t=s2x14yMldPOkXFNXkhykubET47XkQXT0exU6m4Ji2YU",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C4E0BAQEArEwbHMxYRg/company-logo_",
//             },
//           },
//           schoolName: "Bucknell University",
//           trackingId: "3S2mZ/vqQ/mWqS9PLq95pQ==",
//         },
//         grade: "Magna Cum Laude",
//         degreeName: "BSBA",
//         schoolName: "Bucknell University",
//         fieldOfStudy: "Business Management",
//         schoolUrn: "urn:li:fs_miniSchool:19225",
//       },
//       {
//         entityUrn:
//           "urn:li:fs_education:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,86558132)",
//         school: {
//           objectUrn: "urn:li:school:3212430",
//           entityUrn: "urn:li:fs_miniSchool:3212430",
//           active: true,
//           logo: {
//             "com.linkedin.common.VectorImage": {
//               artifacts: [
//                 {
//                   width: 200,
//                   fileIdentifyingUrlPathSegment:
//                     "200_200/company-logo_200_200/0/1630634709278/the_spence_school_06_logo?e=1757548800&v=beta&t=1qq8YMpvayMLB7ve1pUqIp9vthPxzgc-FUI0OdVBZ0U",
//                   expiresAt: 1757548800000,
//                   height: 200,
//                 },
//                 {
//                   width: 100,
//                   fileIdentifyingUrlPathSegment:
//                     "100_100/company-logo_100_100/0/1630634709278/the_spence_school_06_logo?e=1757548800&v=beta&t=nwPsSLURjdPkgm-zujHPAuX2bN8kOlFEDbaLkMa-QtM",
//                   expiresAt: 1757548800000,
//                   height: 100,
//                 },
//                 {
//                   width: 400,
//                   fileIdentifyingUrlPathSegment:
//                     "400_400/company-logo_400_400/0/1630634709278/the_spence_school_06_logo?e=1757548800&v=beta&t=LzLLwmvhG1CGeXCbfDbnf2R1mToZZgK87C_DAqIn4J8",
//                   expiresAt: 1757548800000,
//                   height: 400,
//                 },
//               ],
//               rootUrl:
//                 "https://media.licdn.com/dms/image/v2/C4E0BAQE-HPUOXjmBdQ/company-logo_",
//             },
//           },
//           schoolName: "The Spence School",
//           trackingId: "FsBdtuUyRt2sYsacma2MwQ==",
//         },
//         schoolName: "The Spence School",
//         schoolUrn: "urn:li:fs_miniSchool:3212430",
//       },
//     ],
//   },
//   organizationView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_organizationView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   projectView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_projectView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   positionView: {
//     paging: {
//       start: 0,
//       count: 5,
//       total: 11,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_positionView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         entityUrn:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,2391260019)",
//         companyName: "LinkedIn",
//         timePeriod: {
//           startDate: {
//             month: 5,
//             year: 2024,
//           },
//         },
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:1337",
//             entityUrn: "urn:li:fs_miniCompany:1337",
//             name: "LinkedIn",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//               },
//             },
//             universalName: "linkedin",
//             dashCompanyUrn: "urn:li:fsd_company:1337",
//             trackingId: "STE3KKZRTrOOMhu8ALBipw==",
//           },
//           employeeCountRange: {
//             start: 10001,
//           },
//           industries: ["Computer Software"],
//         },
//         title: "VP Product, Chief of Staff to the Chief Product Officer",
//         companyUrn: "urn:li:fs_miniCompany:1337",
//       },
//       {
//         locationName: "San Francisco Bay Area",
//         entityUrn:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,2067590443)",
//         geoLocationName: "San Francisco Bay Area",
//         geoUrn: "urn:li:fs_geo:90000084",
//         companyName: "LinkedIn",
//         timePeriod: {
//           endDate: {
//             month: 5,
//             year: 2024,
//           },
//           startDate: {
//             month: 11,
//             year: 2022,
//           },
//         },
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:1337",
//             entityUrn: "urn:li:fs_miniCompany:1337",
//             name: "LinkedIn",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//               },
//             },
//             universalName: "linkedin",
//             dashCompanyUrn: "urn:li:fsd_company:1337",
//             trackingId: "7i+vPdCaTLS3uy9V1NEyxA==",
//           },
//           employeeCountRange: {
//             start: 10001,
//           },
//           industries: ["Computer Software"],
//         },
//         title:
//           "Senior Director of Product, Chief of Staff to the Chief Product Officer",
//         region: "urn:li:fs_region:(us,84)",
//         companyUrn: "urn:li:fs_miniCompany:1337",
//       },
//       {
//         entityUrn:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1717977049)",
//         companyName: "LinkedIn",
//         timePeriod: {
//           endDate: {
//             month: 11,
//             year: 2022,
//           },
//           startDate: {
//             month: 12,
//             year: 2020,
//           },
//         },
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:1337",
//             entityUrn: "urn:li:fs_miniCompany:1337",
//             name: "LinkedIn",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//               },
//             },
//             universalName: "linkedin",
//             dashCompanyUrn: "urn:li:fsd_company:1337",
//             trackingId: "C65RxK3sQDCxNWLdpXW9yw==",
//           },
//           employeeCountRange: {
//             start: 10001,
//           },
//           industries: ["Computer Software"],
//         },
//         title:
//           "Director of Product, Chief Of Staff to the Chief Product Officer",
//         companyUrn: "urn:li:fs_miniCompany:1337",
//       },
//       {
//         entityUrn:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1374234822)",
//         companyName: "LinkedIn",
//         timePeriod: {
//           endDate: {
//             month: 12,
//             year: 2020,
//           },
//           startDate: {
//             month: 11,
//             year: 2018,
//           },
//         },
//         description:
//           "Growth team - Led the product team responsible for acquisition (SEO, Logged out Experience, Mobile app downloads) & activation: helping members discover & learn how to use LinkedIn (new user onboarding experience & re-engagement of infrequent members)",
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:1337",
//             entityUrn: "urn:li:fs_miniCompany:1337",
//             name: "LinkedIn",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=7r0g6IjDYANT3Ut-FwP_WGrUsa9F6iy8F4x_TKiDytw",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=EzmQAueYslx87PVnk4zr2ZcUYAFJktRPz8T0SwYaQYQ",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1638831590218/linkedin_logo?e=1757548800&v=beta&t=4o6iHw22fOdHBT7Mwg3EJLtuRr3sTEdsK8S48Xs1674",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/C560BAQHaVYd13rRz3A/company-logo_",
//               },
//             },
//             universalName: "linkedin",
//             dashCompanyUrn: "urn:li:fsd_company:1337",
//             trackingId: "RUCBb+HoRN6MIurkJJ3EFg==",
//           },
//           employeeCountRange: {
//             start: 10001,
//           },
//           industries: ["Computer Software"],
//         },
//         title: "Group Product Manager",
//         companyUrn: "urn:li:fs_miniCompany:1337",
//       },
//       {
//         locationName: "San Francisco Bay Area",
//         entityUrn:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1082127751)",
//         geoLocationName: "San Francisco Bay Area",
//         geoUrn: "urn:li:fs_geo:90000084",
//         companyName: "The Contemporary Jewish Museum",
//         timePeriod: {
//           endDate: {
//             month: 6,
//             year: 2020,
//           },
//           startDate: {
//             month: 5,
//             year: 2017,
//           },
//         },
//         description: "Board Of Trustees, Member-At-Large",
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:85736",
//             entityUrn: "urn:li:fs_miniCompany:85736",
//             name: "The Contemporary Jewish Museum",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=Y9p7qcrzXDK1j3CbpNFvi6EuISwnax4jaYH6LOi1C4E",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=kBuvjEydS8fCWeGZZtep81ER_K2JhhQdC_USYRmF4Ho",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1630599468092/the_contemporary_jewish_museum_logo?e=1757548800&v=beta&t=3lD_mYl-Gj-Gq-UwMfLT_iGZoO2bagYY8ZH191PKZss",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/C560BAQGrdQcL1Zq-tA/company-logo_",
//               },
//             },
//             universalName: "the-contemporary-jewish-museum",
//             dashCompanyUrn: "urn:li:fsd_company:85736",
//             trackingId: "IzCU3MDOTHy9+gaMwxR8DA==",
//           },
//           employeeCountRange: {
//             start: 51,
//             end: 200,
//           },
//           industries: ["Museums and Institutions"],
//         },
//         title: "Board Of Trustees",
//         region: "urn:li:fs_region:(us,84)",
//         companyUrn: "urn:li:fs_miniCompany:85736",
//       },
//     ],
//   },
//   profile: {
//     industryName: "Computer Software",
//     lastName: "Gasarch",
//     supportedLocales: [
//       {
//         country: "US",
//         language: "en",
//       },
//     ],
//     locationName: "United States",
//     student: false,
//     geoCountryName: "United States",
//     geoCountryUrn: "urn:li:fs_geo:103644278",
//     versionTag: "115094513",
//     geoLocationBackfilled: false,
//     elt: false,
//     industryUrn: "urn:li:fs_industry:4",
//     defaultLocale: {
//       country: "US",
//       language: "en",
//     },
//     firstName: "Shira",
//     showEducationOnProfileTopCard: true,
//     entityUrn: "urn:li:fs_profile:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     geoLocation: {
//       geoUrn: "urn:li:fs_geo:90000084",
//     },
//     geoLocationName: "San Francisco Bay Area",
//     location: {
//       basicLocation: {
//         countryCode: "us",
//       },
//     },
//     miniProfile: {
//       firstName: "Shira",
//       lastName: "Gasarch",
//       dashEntityUrn:
//         "urn:li:fsd_profile:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//       occupation:
//         "VP of Product & Chief of Staff to the Chief Product Officer at LinkedIn",
//       objectUrn: "urn:li:member:22503354",
//       entityUrn:
//         "urn:li:fs_miniProfile:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//       backgroundImage: {
//         "com.linkedin.common.VectorImage": {
//           artifacts: [
//             {
//               width: 800,
//               fileIdentifyingUrlPathSegment:
//                 "200_800/profile-displaybackgroundimage-shrink_200_800/0/1659036890078?e=1757548800&v=beta&t=-vfgk1zgw0hBc15uB8v12iWG8VG9u-6M5Z6wtoRdg60",
//               expiresAt: 1757548800000,
//               height: 200,
//             },
//             {
//               width: 1400,
//               fileIdentifyingUrlPathSegment:
//                 "350_1400/profile-displaybackgroundimage-shrink_350_1400/0/1659036890078?e=1757548800&v=beta&t=2Ed0dRI9Hrn-6kNy36pPeoxat6K8Ov86wD9CiFEU1UU",
//               expiresAt: 1757548800000,
//               height: 350,
//             },
//           ],
//           rootUrl:
//             "https://media.licdn.com/dms/image/v2/C4E16AQH6dyO0_Mqk8g/profile-displaybackgroundimage-shrink_",
//         },
//       },
//       publicIdentifier: "shiragasarch",
//       picture: {
//         "com.linkedin.common.VectorImage": {
//           artifacts: [
//             {
//               width: 100,
//               fileIdentifyingUrlPathSegment:
//                 "100_100/profile-displayphoto-shrink_100_100/0/1610575871056?e=1757548800&v=beta&t=AUbMks3G6hJKf-LunvZVHkWPNh6vFyyX6h8t69fxaRY",
//               expiresAt: 1757548800000,
//               height: 100,
//             },
//             {
//               width: 200,
//               fileIdentifyingUrlPathSegment:
//                 "200_200/profile-displayphoto-shrink_200_200/0/1610575871056?e=1757548800&v=beta&t=5SX93QYJkP9b0vyJEwihHpg4iphGdjU7SJ5_ahxJL-c",
//               expiresAt: 1757548800000,
//               height: 200,
//             },
//             {
//               width: 307,
//               fileIdentifyingUrlPathSegment:
//                 "400_400/profile-displayphoto-shrink_400_400/0/1610575871057?e=1757548800&v=beta&t=WmZ9epyUk3HZlwpksmPx8ImP86CQb5t_k0ozgl-etS0",
//               expiresAt: 1757548800000,
//               height: 307,
//             },
//             {
//               width: 307,
//               fileIdentifyingUrlPathSegment:
//                 "800_800/profile-displayphoto-shrink_800_800/0/1610575871057?e=1757548800&v=beta&t=65sEg2szZJzTNhreSVT9G05SEPOHK7HvlPSbnarOS24",
//               expiresAt: 1757548800000,
//               height: 307,
//             },
//           ],
//           rootUrl:
//             "https://media.licdn.com/dms/image/v2/C4E03AQFr7FLre0HTrQ/profile-displayphoto-shrink_",
//         },
//       },
//       trackingId: "KYMMumbuRomH8fMHihj4CA==",
//     },
//     headline:
//       "VP of Product & Chief of Staff to the Chief Product Officer at LinkedIn",
//   },
//   languageView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_languageView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   certificationView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_certificationView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   testScoreView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_testScoreView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   volunteerCauseView: {
//     paging: {
//       start: 0,
//       count: 0,
//       total: 0,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_volunteerCauseView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   entityUrn: "urn:li:fs_profileView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//   courseView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 1,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_courseView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         name: "Stanford University, Computer Science",
//         number: "101",
//         occupation:
//           "urn:li:fs_position:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,829877197)",
//         entityUrn:
//           "urn:li:fs_course:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,205736794)",
//       },
//     ],
//   },
//   honorView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_honorView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
//   skillView: {
//     paging: {
//       start: 0,
//       count: 4,
//       total: 30,
//       links: [],
//     },
//     entityUrn: "urn:li:fs_skillView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         name: "Analytical Skills",
//         entityUrn:
//           "urn:li:fs_skill:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1435507568)",
//       },
//       {
//         name: "Team Leadership",
//         entityUrn:
//           "urn:li:fs_skill:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1435489658)",
//       },
//       {
//         name: "Communication",
//         entityUrn:
//           "urn:li:fs_skill:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1435471837)",
//       },
//       {
//         name: "Strategy",
//         entityUrn:
//           "urn:li:fs_skill:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1435453340)",
//       },
//     ],
//   },
//   volunteerExperienceView: {
//     paging: {
//       start: 0,
//       count: 3,
//       total: 1,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_volunteerExperienceView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [
//       {
//         role: "Nepal Trek Team",
//         entityUrn:
//           "urn:li:fs_volunteerExperience:(ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY,1427197335)",
//         companyName: "buildOn",
//         timePeriod: {
//           endDate: {
//             year: 2014,
//           },
//           startDate: {
//             year: 2014,
//           },
//         },
//         cause: "EDUCATION",
//         description:
//           "Trek team traveling to the village of Belkundi to complete buildOn's 626th school build\n\n ",
//         company: {
//           miniCompany: {
//             objectUrn: "urn:li:company:709228",
//             entityUrn: "urn:li:fs_miniCompany:709228",
//             name: "buildOn",
//             showcase: false,
//             active: true,
//             logo: {
//               "com.linkedin.common.VectorImage": {
//                 artifacts: [
//                   {
//                     width: 200,
//                     fileIdentifyingUrlPathSegment:
//                       "200_200/company-logo_200_200/0/1731541894256?e=1757548800&v=beta&t=gkmhTH-yGiVU8C0dEuTSnumCHygNbYC3JA70f9LGy64",
//                     expiresAt: 1757548800000,
//                     height: 200,
//                   },
//                   {
//                     width: 100,
//                     fileIdentifyingUrlPathSegment:
//                       "100_100/company-logo_100_100/0/1731541894256?e=1757548800&v=beta&t=E1BEKmZQJgGkMcRm19x7mb4FDN_h1G-7TsmwIetgDoI",
//                     expiresAt: 1757548800000,
//                     height: 100,
//                   },
//                   {
//                     width: 400,
//                     fileIdentifyingUrlPathSegment:
//                       "400_400/company-logo_400_400/0/1731541894256?e=1757548800&v=beta&t=FIQub1oZsNZ9VAziebJczN70GeJG0qSms2_qScwNtAM",
//                     expiresAt: 1757548800000,
//                     height: 400,
//                   },
//                 ],
//                 rootUrl:
//                   "https://media.licdn.com/dms/image/v2/D560BAQFDg10BXU4yfg/company-logo_",
//               },
//             },
//             universalName: "buildon",
//             dashCompanyUrn: "urn:li:fsd_company:709228",
//             trackingId: "Y05vq5ebQteVKAscDxEKIw==",
//           },
//         },
//         companyUrn: "urn:li:fs_miniCompany:709228",
//       },
//     ],
//   },
//   primaryLocale: {
//     country: "US",
//     language: "en",
//   },
//   publicationView: {
//     paging: {
//       start: 0,
//       count: 10,
//       total: 0,
//       links: [],
//     },
//     entityUrn:
//       "urn:li:fs_publicationView:ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     profileId: "ACoAAAFXX7oBek_xZvsDxDuXY2C34mDEENwebJY",
//     elements: [],
//   },
// };
